function calculatePrice() {
  console.log('loading');
  function numberWithCommas(x) {
    if (x || x === 0) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }
  }

  var totalPriceBlock = $('#total-price');
  var summaryTotalPrice = $('#summary-total-price');
  var coinsurancesJs = $('.coinsurances-js');
  var addedInsuranceJs = $('.added-insurance-js');
  var actualSubjectId = $('#insurance-subject-id').val();
  var actualSubjectBlock = $('#' + actualSubjectId);
  var selectInsuranceSubject = $('.select-insurance-subject');
  let customSelect = $('.custom-select');
  let obligatoryCheckbox = $('.obligatory-checkbox');
  const locale = $('#locale').val();
  let currencySymbol = 'Kč';

  if (locale === 'sk') {
    currencySymbol = '€';
  }

  $(document).ready(function () {
    calculateDisplayPrice();
  });

  if ($('#toggle-checkbox').length) {
    let toggle = $('#toggle-checkbox');
    toggle.on('click', function () {
      if (toggle.is(':checked')) {
        customSelect.each(function () {
          displayObligatory($(this));
        });
        $('.added-obligatory').removeClass('is-hidden');
        $('.obligatory-section').removeClass('is-hidden');
        $('.obligatory-alert').removeClass('is-hidden');
      } else {
        let customSelect = $('.custom-select');
        var orderId = customSelect.data('order-id');
        $('.summary-obligatory').remove();
        $('.added-obligatory').addClass('is-hidden');
        $('.obligatory-section').addClass('is-hidden');
        $('.obligatory-alert').addClass('is-hidden');
        $.ajax({
          type: 'POST',
          url: '/update/obligatory-delete',
          success: function () {
            //TODO nějaká notifikace?
          },
        });

        calculateDisplayPrice();
      }
    });
  }

  coinsurancesJs.on('click', function (event) {
    if ($(this).children('input[type=radio]').is(':checked')) {
      calculateDisplayPrice();
    }
  });

  addedInsuranceJs.on('click', function (event) {
    calculateDisplayPrice();
  });

  selectInsuranceSubject.on('click', function (event) {
    $('#subject-coinsurances').addClass('is-hidden');
    $('#subject-added-insurances').addClass('is-hidden');
  });

  obligatoryCheckbox.on('click', function () {
    displayObligatory($(this).parent().find('input[type=checkbox]'));
  });

  let couponCodeInput = $('.coupon-code-input');
  couponCodeInput.each(function () {
    let form = $(this).closest('form');
    let url = form.attr('action');
    $(this).on('change', function (event) {
      $.ajax({
        type: 'POST',
        url: url,
        data: form.serialize(), // serializes the form's elements.
        success: function (data) {
          var startDate = new Date(data.dateFrom);
          var endDate = new Date(data.dateTo);
          $('.date-start-text').html(
            startDate.getDate() +
              '.' +
              (startDate.getMonth() + 1) +
              '.' +
              startDate.getFullYear() +
              ' do ' +
              endDate.getDate() +
              '.' +
              (endDate.getMonth() + 1) +
              '.' +
              endDate.getFullYear()
          );
          $('.coupon-response').html(
            data.text +
              '<span class="discount-price-value">' +
              data.value +
              '</span>'
          );
          let discountType = $('#discount-type-hidden');
          discountType.attr('value', data.type);
          let hiddenPrice = document.getElementById('discount-type-hidden');
          hiddenPrice.dataset.percentage = data.valuePrice;
          calculateDisplayPrice();
          //TODO nastavit např. zelený box u inputu
        },
        error: function (data) {
          $('.coupon-response').html(data.responseJSON);
          //TODO nastavit např. zelený box u inputu
        },
      });
    });
  });

  function calculateDisplayPrice() {
    $('.summary-added-insurance-actual').remove();

    var selectedCoinsurance = $(
      "input[name='insurance_subject_order[coinsurance]']:checked"
    );
    var coinsurancePrice = selectedCoinsurance.data('price');
    var coinsuranceName = selectedCoinsurance.data('name');
    var coinsuranceLength = selectedCoinsurance.data('length');
    if (coinsurancePrice === undefined) {
      coinsurancePrice = actualSubjectBlock
        .find('.summary-subject-price-js')
        .data('price');
    }

    if (coinsuranceLength) {
      var startDateStr = $('#possible-date-from').val();
      const [day, month, year] = startDateStr.split('.').map(Number);
      var startDate = new Date(year, month - 1, day);
      var now = new Date();
      var endDate = new Date(
        new Date(now).setMonth(now.getMonth() + coinsuranceLength)
      );
      $('.date-start-text').html(
        startDate.getDate() +
          '.' +
          (startDate.getMonth() + 1) +
          '.' +
          startDate.getFullYear() +
          ' do ' +
          endDate.getDate() +
          '.' +
          (endDate.getMonth() + 1) +
          '.' +
          endDate.getFullYear()
      );
    }

    let securityAdded = false;
    let stepSecurityAdded = false;
    $('.added-insurance-checkbox:checked').each(function () {
      actualSubjectBlock
        .find('.' + $(this).data('type'))
        .find('.summary__item--group-headline')
        .removeClass('is-hidden');

      stepSecurityAdded = true;
      if ($(this).data('type') === 'added-security') {
        securityAdded = true;
      }

      actualSubjectBlock
        .find('.' + $(this).data('type'))
        .append(
          '<div class="summary__item summary__item--upsell summary-added-insurance-actual">' +
            $(this).data('name') +
            '<span class="js-data-price" data-price="' +
            $(this).data('price') +
            '">' +
            numberWithCommas($(this).data('price')) +
            ' ' +
            currencySymbol +
            '</span>' +
            '</div>'
        );
    });

    if (
      $('.added-insurance-checkbox:checked').length === 0 ||
      (stepSecurityAdded && !securityAdded)
    ) {
      if ($('.added-insurance-checkbox').length) {
        actualSubjectBlock
          .find('.added-security')
          .find('.summary__item--group-headline')
          .addClass('is-hidden');
      }
    }

    actualSubjectBlock
      .find('.summary-subject-price-js')
      .text(numberWithCommas(coinsurancePrice) + ' ' + currencySymbol)
      .data('price', coinsurancePrice);
    actualSubjectBlock.find('.summary-subject-name-js').text(coinsuranceName);

    var totalPrice = updatePrice();

    // update ceny do tmpTotalPrice v MasterOrder
    $.ajax({
      type: 'POST',
      url: '/change/tmpTotalPrice',
      data: { tmpTotalPrice: totalPrice, coinsuranceLength: coinsuranceLength }, // serializes the form's elements.
      success: function (data) {
        if (data) {
          var subjectPrices = data.subjectPrices;
          subjectPrices.forEach(function (subjectPrice) {
            $('#' + subjectPrice.id)
              .find('.summary-subject-price-js')
              .text(numberWithCommas(subjectPrice.price) + ' ' + currencySymbol)
              .data('price', subjectPrice.price);
            $('#' + subjectPrice.id)
              .find('.summary-subject-name-js')
              .text(subjectPrice.name);
          });
          updatePrice();
        }
      },
      error: function (data) {
        console.log(data);
        //TODO nastavit např. zelený box u inputu
      },
    });
  }

  function displayObligatory(checkbox) {
    let isAdded = !checkbox.is(':checked');
    let orderId = checkbox.data('order-id');
    if (orderId) {
      $('#' + orderId)
        .find('.added-obligatory')
        .children('.summary-obligatory')
        .remove();
      $('#' + orderId)
        .find('.added-obligatory')
        .find('.summary__item--group-headline')
        .addClass('is-hidden');
      if (isAdded) {
        $('#' + orderId)
          .find('.added-obligatory')
          .find('.summary__item--group-headline')
          .removeClass('is-hidden');
        $('#' + orderId)
          .find('.added-obligatory')
          .append(
            '' +
              '<div class="summary__item summary__item--upsell summary-added-insurance summary-obligatory">' +
              checkbox.data('name') +
              '<span class="js-data-price" data-price="' +
              checkbox.data('price') +
              '">' +
              numberWithCommas(checkbox.data('price')) +
              ' ' +
              currencySymbol +
              '</span>' +
              '</div>'
          );
      }
      calculateDisplayPrice();
    }
  }

  function updatePrice() {
    var totalPrice = 0;
    $('.js-data-price').each(function () {
      totalPrice += $(this).data('price');
    });

    let quantityDiscount = $('#quantity-discount');
    if (quantityDiscount) {
      if (quantityDiscount.data('type') === 2) {
        var percentage = parseInt(quantityDiscount.data('value'));
        var discount = Math.round((totalPrice * percentage) / 100);
        totalPrice -= discount;
        $('.quantity-discount-price-value').html(
          '- ' + discount + ' ' + currencySymbol
        );
      }
    }

    let discountType = $('#discount-type-hidden');
    if (discountType.attr('value') == 1) {
      var discount1 = parseInt(
        document.getElementById('discount-type-hidden').dataset.percentage
      );
      totalPrice -= discount1;
      $('.discount-price-value').each(function () {
        $(this).html('- ' + discount1 + ' ' + currencySymbol);
      });
    } else if (discountType.attr('value') == 2) {
      var percentage = parseInt(
        document.getElementById('discount-type-hidden').dataset.percentage
      );
      var discount = Math.round((totalPrice * percentage) / 100);
      totalPrice -= discount;
      $('.discount-price-value').each(function () {
        $(this).html('- ' + discount + ' ' + currencySymbol);
      });
    }

    totalPriceBlock.text(numberWithCommas(totalPrice) + ' ' + currencySymbol);
    summaryTotalPrice.text(numberWithCommas(totalPrice) + ' ' + currencySymbol);
    let summaryEndTotalPrice = $('#summary-end-total-price');
    if (summaryEndTotalPrice.length) {
      summaryEndTotalPrice.text(
        numberWithCommas(totalPrice) + ' ' + currencySymbol
      );
    }
    let endTotalPrice = $('#end-payment-total-price');
    if (endTotalPrice.length) {
      endTotalPrice.text(numberWithCommas(totalPrice) + ' ' + currencySymbol);
    }

    return totalPrice;
  }
}
